<div>
  <HomeNavBar />

  <!-- Loader -->
  <div v-if="is_loading" class="superset-loader d-flex justify-content-center align-items-center">
    <div class="loader-card">
      <div class="spinner"></div>
      <h6 class="mt-3">Loading dashboard</h6>
      <small>Please wait while data is being prepared…</small>
    </div>
  </div>

  <!-- Superset Dashboard -->
  <div class="dashboard-wrapper" :class="{ 'interactive': is_dashboard_interactive }" v-show="!is_loading">
    <div id="dashboard-container" class="dashboard-container"></div>
  </div>
</div>